import * as $ from "jquery";
import imkt from '../../imkt';

imkt.wac.GetStarted = class GetStarted {
  $domRoot: HTMLElement;
  params: {};
  domRootHeight: any;
  serverWrap: JQuery<HTMLElement>;
  serverWrapHeight: any;
  server: JQuery<HTMLElement>;
  serverColumns: JQuery<HTMLElement>;
  cloud: JQuery<HTMLElement>;
  cloudHeight: any;
  
  constructor(domRoot: HTMLElement, params: {}) {
    (this.$domRoot = domRoot || $("body")), (this.params = { ...params });

    this.init();
  }

  init() {
    this.resetVariables();
    this.resize();
    this.fixServer();
    this.bindEvents();
  }

  resetVariables() {
    this.domRootHeight = this.$domRoot.height();
    this.serverWrap = $("#serverWrap");
    this.serverWrapHeight = this.serverWrap.height();
    this.server = $(".section-looking-for-server");
    this.serverColumns = $(".section-looking-for-server__columns");
    this.cloud = $(".section-hosted-in-cloud");
    this.cloudHeight = this.cloud.height();
  }

  bindEvents() {
    var self = this;
    var speed = 300;
    self.server.on("click", function () {
      if (!self.serverWrap.hasClass("active")) {
        self.serverWrap
          .addClass("active")
          .animate({ "margin-top": -self.cloudHeight }, speed);
        self.serverColumns.slideDown(speed);
        self.cloud.animate({ opacity: 0 }, speed);
        $("html, body").animate({ scrollTop: $(document).height() }, speed);
      } else {
        self.cloud.animate({ opacity: 1 }, speed);
        self.serverWrap
          .removeClass("active")
          .animate({ "margin-top": 0 }, speed);
        self.serverColumns.slideUp(speed);
      }
    });
  }

  resize() {
    var self = this;
    $(window).on("resize", function () {
      clearTimeout(self.resizeTimer);
      self.resizeTimer = setTimeout(function () {
        self.resetVariables();
        self.fixServer();
      }, 50);
    });
  }

  fixServer() {
    if (
      this.domRootHeight - this.serverWrapHeight > 640 &&
      $(window).width() > 800
    ) {
      this.serverWrap.addClass("fixed");
    } else {
      this.serverWrap.removeClass("fixed");
    }
  }
}

new imkt.wac.GetStarted();
